import { Component, OnInit, Input, TemplateRef, QueryList, ViewChildren } from '@angular/core';
import { ContentHeaderBarService } from './content-header-bar.service';
import { ContentHeaderButton, ContentHeaderLink } from '../../models';
import { MdePopoverTrigger } from '@material-extended/mde';


@Component({
  selector: 'app-content-header-bar',
  templateUrl: './content-header-bar.component.html',
  styleUrls: ['./content-header-bar.component.scss'],
  providers: []
})
export class ContentHeaderBarComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() link: ContentHeaderLink;
  @Input() headerTemplate: TemplateRef<any>;
  @Input() additionalPartnerInfo: string;
  @Input() additionalInfoIconFlag: boolean;
  @ViewChildren(MdePopoverTrigger) trigger: QueryList<MdePopoverTrigger>;

  /**
   * If this is included, the buttons show will be from this list
   * Otherwise, it will use the button list from the ContentHeaderBarService
   *
   * @type {ContentHeaderButton[]}
   * @memberof ContentHeaderBarComponent
   */
  @Input() overrideButtons: ContentHeaderButton[];

  get buttons(): ContentHeaderButton[] {
    return this.overrideButtons ? this.overrideButtons : this.contentHeaderService.buttons;
  }

  constructor(private contentHeaderService: ContentHeaderBarService) {}

  ngOnInit() {}

  onButtonClick(button: ContentHeaderButton) {
    if (button.onClick) {
      button.onClick();
    }
    this.contentHeaderService.onClick.next(button);
  }

  catchChildEvent(id :number) {    
    this.trigger.toArray()[id].togglePopover();    
  }
}
